/* A lazy PDP adapter of the authoritative homepage video-product-grid@1. */
(() => {
  if (customElements.get('guru-community-videos')) return;

  class GuruCommunityVideos extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.style.display = 'block';
      this.style.minHeight = '1px';
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load(this.controller);
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      } else {
        this.load(this.controller);
      }
    }

    async load(controller) {
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(this.dataset.homeUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid community source');
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', priority: 'low' });
        if (!response.ok) throw new Error('Community source unavailable');
        const source = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = source.querySelector('[data-component-contract="video-product-grid@1"]');
        if (!grid?.querySelector('[data-guru-video-product-card]')) throw new Error('No community cards');
        if (controller.signal.aborted || !this.isConnected) return;
        // Import only the canonical component, never homepage scripts or page composition.
        grid.querySelectorAll('script, style, link, iframe, form').forEach((node) => node.remove());
        grid.querySelectorAll('*').forEach((node) => {
          [...node.attributes].forEach(({ name }) => {
            if (/^on/i.test(name)) node.removeAttribute(name);
          });
        });
        this.replaceChildren(document.importNode(grid, true));
        window.GuruMediaPlayback?.initRoot(this);
        window.__guruVideoProductGridV1?.initRoot(this);
        this.dataset.state = 'ready';
      } catch {
        if (this.isConnected && this.controller === controller) {
          this.dataset.state = 'unavailable';
          this.style.display = 'none';
        }
      } finally {
        clearTimeout(timeout);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      window.GuruMediaPlayback?.cleanupRoot(this);
      window.__guruVideoProductGridV1?.cleanupRoot(this);
      this.replaceChildren();
    }
  }
  customElements.define('guru-community-videos', GuruCommunityVideos);
})();
